import axiosApiClient from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/notifications";

class NotificationsService {
  fetchNotifications = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { notifications } = response.data.data;
      return notifications;
    } catch (err) {
      throw handleError(err, "Error occured while fetching notifications.");
    }
  };
}

export default new NotificationsService();
